import { useLocation, Navigate, Outlet, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useAuth from '../hooks/useAuth'
import axios from '../api/axios'

const ServiceAuth = () => {
  const location = useLocation()

  const { auth, setAuth } = useAuth()

  const [loading, setLoading] = useState(true)

  if (loading) return <div>Loading...</div>

  const isImpersonating = !!localStorage.getItem("token")

  if (auth.user || isImpersonating) {
    return <Outlet />
  }

  return <Navigate to='/login' state={{ from: location }} replace />
}

export default ServiceAuth
